import React, { useEffect, useRef } from 'react'

export default function OutsideClickClose({ 
  children, 
  isOpen, 
  onClose,
  className = '',
  containerTag = 'div',
  closeOnEsc = true,
}) {
  const modalRef = useRef()

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose()
    }
  }

  const handleEscKey = (event) => {
    if (closeOnEsc && event.key === 'Escape') {
      onClose()
    }
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('keydown', handleEscKey)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscKey)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscKey)
    }
  }, [isOpen, closeOnEsc])

  if (!isOpen) return null

  const Container = containerTag
  return <Container ref={modalRef} className={className}>{children}</Container>
}
